import {apolloClientNoCache} from '../../apolloClient';
import {
  IssuesTimestampsByMetricQueryDocument,
  type IssuesTimestampsByMetricQueryQuery,
  type IssuesTimestampsByMetricQueryQueryVariables,
} from '../../generated/graphql';

export async function doTimestampsByMetricQuery({
  entityName,
  projectName,
  runName,
  bucketedHistorySpecs,
}: {
  entityName: string;
  projectName: string;
  runName: string;
  bucketedHistorySpecs: string[];
}) {
  return apolloClientNoCache.query<
    IssuesTimestampsByMetricQueryQuery,
    IssuesTimestampsByMetricQueryQueryVariables
  >({
    query: IssuesTimestampsByMetricQueryDocument,
    variables: {
      entityName,
      projectName,
      runName,
      bucketedHistorySpecs,
    },
  });
}
